<template>
	<shutter-panel ref="shutterPanel" />
</template>

<script type="text/javascript">
import Shutter from "@/mixins/Shutter.js"
import ShutterHorse from "@/mixins/shutters-manager/Horse.js"
import Vue from 'vue'

export default {
	name: 'SearchSire',
	mixins: [Shutter, ShutterHorse],
	data () {
		return {
			mask_ifce: false
		}
	},

	mounted() {
		this.init_component()
	},

	methods: {
		init_component() {
			this.mask_ifce = this.getConfigIfce()

			if(this.mask_ifce) {
				this.setupAjoutManuel()
			}
			else {
				this.setupSearchSire()
			}
		}
	}
};

</script>